module.exports = __webpack_public_path__ + "static/media/technique.c8575e11.jpg";